<template>
    <div class="menu-wrapper">

        <div class="menu">
            <button class="menu-btn" @click="choosedRobot('pexercises')"
                :class="robotId === 'pexercises' ? 'selected' : ''">🌱小学智能体</button>
            <button class="menu-btn" @click="choosedRobot('mexercises')"
                :class="robotId === 'mexercises' ? 'selected' : ''">🌿初中智能体</button>
            <button class="menu-btn" @click="choosedRobot('exercises')"
                :class="robotId === 'exercises' ? 'selected' : ''">🌳高中智能体</button>
            <button class="menu-btn" @click="choosedRobot('composition')"
                :class="robotId === 'composition' ? 'selected' : ''">📝组卷智能体</button>
            <!-- <button class="menu-btn" @click="choosedRobot('knowledgeGraph')">🧭高中方法图谱</button> -->
            <button class="menu-btn" @click="openLevel">📈 我的数学水平</button>
            <button class="menu-btn" @click="choosedRobot('wrong')">❌我的错题本</button>
            <button class="menu-btn" @click="choosedRobot('wall')">🧱我的知识墙</button>
            <button class="menu-btn" @click="toCollect('collect')">📁我的收藏本</button>
            <button class="menu-btn" @click="openHistoryPanel">🕒聊天记录</button>
            <collect class="collect-panel" v-show="showCollect" :showCollect="showCollect" :full="true" :isMobile="true"
                @hideCollect="hideCollect">
            </collect>
            <my-level class="level-panel" v-show="showLevel" :showLevel="showLevel" :score="score" :full="true"
                @hideLevel="hideLevel"></my-level>
        </div>
    </div>

</template>
<script>
import store from "@/store/index";
import robotMixin from "@/mixin/robot.js";
import collect from "@/components/mobile/collect"
import myLevel from "@/components/mobile/level"


import { mapState } from "vuex/dist/vuex.common.js";

export default {
    name: 'toolbar',
    data() {
        return {
            selected: "exercises",
            showCollect: false,
            showLevel: false,
            ele: {},

        }
    },
    components: {
        collect,
        myLevel
    },
    mixins: [robotMixin],
    computed: {
        ...mapState(['foldRobot', 'foldHistory', "robotId",
            "robots",
            "messageStorage",
            "user",
            "sessionId",
            "robotSessionMap",
            "papers",
            "isMobile"])
    },
    mounted() {
        this.ele = document.querySelector(".user-avatar")
    },
    methods: {
        openRobotPanel() {
            store.commit("SET_FOLDROBOT", false);
        },

        openHistoryPanel() {
            store.commit("SET_FOLDHISTORY", false);
        },
        toCollect() {
            // this.showCollect = true;
            this.$router.push('/collect')
        },
        hideCollect() {
            // this.showCollect = false;
            this.$router.go(-1)
        },
        openLevel() {
            // this.showLevel = true;
            this.$router.push('/level')
            this.choosedRobot('mathLevel')
        },
        hideLevel() {
            // this.showLevel = false
            this.$router.go(-1)
        }

    },
    watch: {
        showLevel(newVal, oldVal) {
            if (newVal) {
                this.ele.style.zIndex = 0
            } else {
                this.ele.style.zIndex = 1

            }
        }

    }

}
</script>
<style lang="scss">
.menu-wrapper {
width: 100%;
overflow-x: auto;            // 保留滚动能力
scrollbar-width: thin;       // Firefox 细条
&::-webkit-scrollbar {
    height: 2px;               // 细滚动条
}
&::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 1px;
}
&::-webkit-scrollbar-track {
    background: transparent;
}
}

.menu {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;
    padding-bottom: 4px;
    padding-top: 1px;
    background-color: var(--rightbox-bg-color);
    .menu-btn {
        margin-right: 10px;
        padding: 5px 8px;
        min-width: fit-content;
        display: flex;
        align-items: center;
        border: 1px solid var(--border-exercise);
        border-radius: 10px;
        color: #000;
        font-size: clamp(12px, 0.14rem, 16px);
        font-weight: 500;
        background-color: #fff;
        cursor: pointer;

        &.selected {
            border: 1px solid var(--txt-color-blue);
            color: var(--txt-color-blue);
        }
    }
}

.collect-panel,
.level-panel {
    position: absolute;
    width: 100vw !important;
    height: 100vh !important;
    left: 0 !important;
    right: 0 !important;
    top: 0;
    background-color: #fff;
    z-index: 100000;

    ::v-deep ul {
        margin-left: 0;
    }

}
</style>